module.exports = __webpack_public_path__ + "img/hero-mobile.8fd904ad.jpg";